<div class="" [hidden]="!isHistory">
    <!--search area-->
    <i class="fa fa-compress" [ngClass]="{'fa-1x':!isHistory,'fa-2x':isHistory}" (click)="toggle()"></i>
    <!--table area-->
    <!--header for column name & field for column content-->
    <div class="">
        <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="visitsList" selectionMode="single" [rows]="10" [totalRecords]="totalRecords" [lazy]="true" (onPage)="paginate($event)" [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]"
            [rowStyleClass]="getCssClasses">
            <p-column field="visitNo" header="{{ 'visitNum' | translate }}" [sortable]="true"></p-column>
            <p-column field="visitSerial" header="{{'accountNo' | translate}}" [sortable]="true"></p-column>

            <p-column header="{{ 'visitType' | translate }}">
                <ng-template pTemplate="options" let-row="rowData">
                    <span [ngClass]="{'text-success': row.visitType == 1, 'text-primary': row.visitType == 2, 'text-danger': row.visitType == 3}">
                        {{translate.currentLang == 'ar' ? row.visitTypeAr : row.visitTypeEn}}
                    </span>
                </ng-template>
            </p-column>

            <p-column field="{{translate.currentLang == 'ar' ? 'docNameAr':'docNameEn'}}" header="{{ 'doctorName' | translate }}" [sortable]="true"></p-column>
            <p-column field="{{translate.currentLang == 'ar' ? 'contractsAr':'contractsEn'}}" header="{{ 'Contract' | translate }}" [sortable]="true"></p-column>
            <p-column field="visitStartDate" header="{{ 'VisitStartDate' | translate }}" [sortable]="true"></p-column>
            <p-column field="visitEndDate" header="{{ 'VISITENDDATE' | translate }}" [sortable]="true"></p-column>
            <p-column header="{{ 'closevisits' | translate }}">
                <ng-template pTemplate="options" let-row="rowData">
                    <!-- <icon-action *ngIf="row.visitStatus != 3" (clicked)="onVisitRowClick($event,row)" [appCodes]="row.allowAddEdit == 1 ? [404,2159,2160] : [2159,2160]"></icon-action> -->
                    <icon-action *ngIf="row.visitStatus != 3 &&  row.visitStatus != 5 " (clicked)="onVisitRowClick($event,row)" [appCodes]="getAppCodes(row.allowAddEdit)"></icon-action>
                </ng-template>
            </p-column>

        </p-dataTable>
    </div>



    <div>
        <block-modal-container #popup (close)="onpopupClose($event)">
            <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
        </block-modal-container>
    </div>

</div>